import { render, staticRenderFns } from "./FormContact.vue?vue&type=template&id=4930f9b0&scoped=true&"
import script from "./FormContact.vue?vue&type=script&lang=js&"
export * from "./FormContact.vue?vue&type=script&lang=js&"
import style0 from "./FormContact.vue?vue&type=style&index=0&id=4930f9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930f9b0",
  null
  
)

export default component.exports